import { Col, Form, Row } from "antd";
import Modal from "antd/lib/modal/Modal";
import React from "react";
import AdnAddButton from "../common/adnAddButton/AdnAddButton";
import AdnCard from "../common/adnCard/AdnCard";
import AdnInput from "../common/adnInput/AdnInput";
import AdnPageTitle from "../common/adnPageTitle/AdnPageTitle";
import AdnTable from "../common/adnTable/AdnTable";
import { useTranslation } from "react-i18next";

export const TechSpecializedListPageForm = ({
  form,
  title,
  columns,
  handleOrderList,
  setVisible,
  visible,
  techs,
  addTech,
  handleFinish,
  modalTechId,
  loading,
  submitLoading,
  handleBlurName,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <AdnPageTitle title={title} />
      <AdnCard loading={loading}>
        <Row>
          <Col span={24}>
            <AdnAddButton
              style={{ float: "right" }}
              name={t("techSpecialized.buttons.addButton")}
              handleClick={addTech}
            />
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <AdnTable
              columns={columns}
              data={techs}
              pagination={false}
              handleChange={handleOrderList}
              totalRecords={techs.length}
            />
          </Col>
        </Row>
      </AdnCard>
      <Modal
        title={
          !modalTechId
            ? t("techSpecialized.modals.newTechSpecialization")
            : t("techSpecialized.modals.editTechSpecialization")
        }
        open={visible}
        onOk={form.submit}
        okText={t("techSpecialized.buttons.save")}
        onCancel={() => {
          setVisible(false);
        }}
        cancelText={t("techSpecialized.buttons.back")}
        confirmLoading={submitLoading}
      >
        <Form
          form={form}
          name="form_in_modal"
          layout="vertical"
          onFinish={handleFinish}
        >
          <AdnInput
            name={"name"}
            label={t("techSpecialized.labels.name")}
            placeholder={t("techSpecialized.placeholders.insertName")}
            handleBlur={handleBlurName}
            maxLength={20}
            rules={[
              {
                required: true,
                message: t("techSpecialized.validation.nameRequired"),
              },
              {
                min: 2,
                message: t("techSpecialized.validation.nameMinLength"),
              },
            ]}
          />
        </Form>
      </Modal>
    </>
  );
};
